export enum Status {
  InProgress = 1,
  Finished = 2,
}
